module.exports = __webpack_public_path__ + "img/horizontal_3_3_pp3_1.36ba03e9.png";